<template>
  <div>
    <div class="section-title" style="text-align: center; margin-top: 40px;">
      Newsletter
    </div>
    <v-container class="container mt-12" fluid>
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
          <v-card shaped elevation="5" class="card  ">
            <!-- <v-toolbar class="rounded-t primary-background" tile>
              <v-toolbar-title>Zapisz się do newslettera</v-toolbar-title>
            </v-toolbar> -->
            <v-container>
              <div class="sub-title">Zapisz się do newslettera</div>
              <ValidationObserver
                ref="obs"
                v-slot="{ invalid, handleSubmit }"
                mode="eager"
              >
                <v-form @submit.prevent="handleSubmit(onSubmit)">
                  <VTextFieldWithValidation
                    rules="email|required"
                    v-model="email"
                    label="E-mail"
                    color="grey"
                    outlined
                    dense
                    :disabled="loading"
                  />
                  <v-checkbox
                    color="#6D6963"
                    v-model="newsletter"
                    :label="
                      `Wyrażam zgodę na otrzymywanie newslettera droga mailową.`
                    "
                  ></v-checkbox>

                  <div
                    class=""
                    style="display: flex; align-items: center; justify-content: center; padding-top: 30px;"
                  >
                    <v-btn
                      type="submit"
                      class="  primary-button"
                      color="#B7B2AA"
                      style="margin:auto; width: fit-content; color:#8B857D"
                      :loading="loading"
                      :disabled="invalid || !newsletter"
                    >
                      Zapisz się
                    </v-btn>
                  </div>
                </v-form>
              </ValidationObserver>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VTextFieldWithValidation from "../components/inputs/VTextFieldWithValidation";
import { ValidationObserver } from "vee-validate";
import axios from "../axios";
import router from "../router";
export default {
  metaInfo: {
    title: "Dagajoga newsletter - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "PaymentPage",
  components: {
    VTextFieldWithValidation,
    ValidationObserver,
  },
  data: () => ({
    email: "",
    loading: false,
    newsletter: false,
  }),
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    async onSubmit() {
      this.loading = true;
      const response = await this.addToNewsletter();
      if (response.status === 200) {
        router.push({ name: "NewsletterSuccess" });
      }
    },

    async addToNewsletter() {
      return await axios.post(`management/newsletter`, {
        email: this.email,
      });
    },
  },
};
</script>

<style scoped>
.container {
  margin-bottom: 2rem;
}
.reset {
  text-transform: uppercase;
  cursor: pointer;
}
.submit-button {
  background-color: #cc6666 !important;
  font-size: 1.1rem;
}
.card {
  background-color: #d9d9d9 !important;
  color: #54514c;
  border-radius: 32px !important;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5 !important;
  margin: auto;
}
</style>
